<div class="export-modal">
  <div class="modal-header">
    <div class="export-modal-header">
      <h6 class="mandatory">{{translate?.report.messages.selectAFileType}}</h6>
      <p class="sub">{{translate?.report.messages.selectTypeFileToExport}} {{translate?.report.label.singular}}
        {{translate?.report.messages.in}}</p>
    </div>
    <button type="button" class="close" data-dismiss="modal" [pTooltip]="translate?.general.buttons.close.singular"
      tooltipPosition="left" (click)="modalRef.hide();">
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  <form [formGroup]="exportForm">
    <div class="modal-body">
      <!-- SELECT A FILE TYPE -->
       <section class="section">
          <div class="filetype mt-0">
            <!-- CSV -->
            <div class="filetype__option">
              <input type="radio" id="ex-csv" value="csv" formControlName="fileType" checked>
              <label for="ex-csv" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i class="filetype__icon fa fa-file-text-o" aria-hidden="true"></i>
                  <span class="filetype__title">{{translate?.report.fields.csv.singular}}</span>
                </div>
                <span class="filetype__desc">{{translate?.report.messages.csvDescription}}.</span>
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>

            <!-- Excel -->
            <div class="filetype__option">
              <input type="radio" id="ex-xls" value="excel" formControlName="fileType">
              <label for="ex-xls" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i class="filetype__icon fa fa-file-excel-o" aria-hidden="true"></i>
                  <span class="filetype__title">{{translate?.report.fields.excel.singular}}</span>
                </div>
                <span class="filetype__desc">{{translate?.report.messages.excelDescription}}.</span>
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>

            <!-- PDF -->
            <div class="filetype__option">
              <input type="radio" id="ex-pdf" value="pdf" formControlName="fileType">
              <label for="ex-pdf" class="filetype__card">
                <div class="flex-align-center gap-2">
                  <i class="filetype__icon fa fa-file-pdf-o" aria-hidden="true"></i>
                  <span class="filetype__title">{{translate?.report.fields.pdf.singular}}</span>
                </div>
                <span class="filetype__desc">{{translate?.report.messages.pdfDescription}}.</span>
                <span class="filetype__check" aria-hidden="true"></span>
              </label>
            </div>
          </div>
       </section>

      <!-- SEND REPORT VIA EMAIL -->
      <section class="section">
          <div class="section__title">
              <div class="header-title">
                  <div class="title">{{translate?.report.messages.doYouWantToSendThis}} {{translate?.report.label.singular}} {{translate?.report.messages.to}} {{translate?.setup.users.users.label.plural}} {{translate?.report.messages.viaEmail}}?</div>
                  <p-inputSwitch formControlName="sendEmail" [styleClass]="'mt-10px'" id="aggregateSwitch"  (onChange)="onSwitchChange($event)"></p-inputSwitch>
              </div>
          </div>
      </section>

      <!-- SELECT EMAIL RECIPIENTS -->
        <section class="section" *ngIf="exportForm.get('sendEmail').value === true" >
        <!-- <section class="section"> -->
            <div class="section__title">
                <div class="header-title">
                    <div class="title">{{translate?.report.messages.selectEmailRecipient}}</div>
                </div>
                <div class="sub">{{translate?.report.messages.selectRecipientsAtLeastOne}}</div>
            </div>
              <div class="grid-2">
                <div>
                  <label class="field-label">{{translate?.setup.users.users.label.plural}}</label>
                  <div>
                    <p-multiSelect optionLabel="fullName" optionValue="id" [filter]="true" [options]="users"
                      class="w-100 reports-select" [showToggleAll]="false" display="chip" formControlName="recipientsUser"
                      (onChange)="onUsersChange()" [placeholder]="translate?.report.messages.selectUser+'...'" [panelStyle]="{ 'min-height': '380px' }">
                    </p-multiSelect>
                
                    <div class="p-error text-10" *ngIf="exportForm.controls['recipientsUser'].touched && exportForm.controls['recipientsUser'].invalid">
                        {{translate?.report.validationFE.atLeastOneIsRequired}}
                    </div>
                
                  </div>
                </div>
              
                <div>
                  <label class="field-label">{{translate?.setup.users.groups.label.plural}}</label>
                  <div>
                    <p-multiSelect optionLabel="name" optionValue="id" [filter]="true" [options]="user_groups"
                      formControlName="recipientsGroup" class="w-100 reports-select" [showToggleAll]="false" display="chip"
                      (onChange)="onGroupChange()" [placeholder]="translate?.report.messages.selectGroup+'...'" [panelStyle]="{ 'min-height': '380px' }">
                    </p-multiSelect>

                    <div class="p-error text-10" *ngIf="exportForm.controls['recipientsGroup'].touched && exportForm.controls['recipientsGroup'].invalid">
                        {{translate?.report.validationFE.atLeastOneIsRequired}}
                    </div>
                  </div>
                </div>
              
               
              </div>

            <div class="grid-2">
                <div>
                     <label class="field-label">{{translate?.setup.users.users.fields.email.singular}}</label>
                     <div>
                        <p-chips formControlName="otherRecipients" 
                            (onAdd)="onEmailAdd($event)" (onRemove)="onEmailRemove($event)"
                            [placeholder]="translate?.report.messages.enterEmailAddresses+'...'"
                            [ngClass]="{'ng-invalid ng-dirty': exportForm.controls['otherRecipients']?.touched && exportForm.controls['otherRecipients'].invalid}">
                        </p-chips> 
                        <div class="p-error text-10 mt-1" 
                            *ngIf="exportForm.controls['otherRecipients']?.touched && exportForm.controls['otherRecipients'].invalid ">
                            <span 
                                *ngIf="exportForm.controls['otherRecipients']?.errors?.email"  >{{translate?.general.validationFE.invalidEmailFormat}}
                            </span>
                            <span *ngIf="exportForm.controls['otherRecipients']?.errors?.required">
                                {{translate?.report.validationFE.atLeastOneIsRequired}}
                            </span>
                        </div>
                     </div>
                </div>
            </div>
        </section>

    </div>

    <div class="modal-footer">
      <button type="button" class="custella-btn-white"
        (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
      <p-button [label]="translate?.setup.importExport.sections.sec1.singular" styleClass="h-32" (onClick)="onExportClick()"
        [disabled]="exportForm.invalid"></p-button>
    </div>
  </form>
</div>